import React from 'react';
export const PresentDrop = () => (
  <svg width="163px" height="137px" viewBox="0 0 163 137" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1056.000000, -1462.000000)">
        <g transform="translate(1056.000000, 1461.000000)">
          <path
            d="M120.5982,74.7094 L120.5982,76.0254"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M120.5982,78.6567 L120.5982,79.9717"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M123.2296,77.3412 L121.9136,77.3412"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M119.2823,77.3412 L117.9673,77.3412"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M127.9175,86.6342 C127.9175,87.1162 127.5265,87.5082 127.0435,87.5082 C126.5615,87.5082 126.1695,87.1162 126.1695,86.6342 C126.1695,86.1522 126.5615,85.7602 127.0435,85.7602 C127.5265,85.7602 127.9175,86.1522 127.9175,86.6342"
            fill="#D62793"
          />
          <path
            d="M59.4976,85.1957 C59.4976,85.6777 59.1066,86.0697 58.6236,86.0697 C58.1416,86.0697 57.7496,85.6777 57.7496,85.1957 C57.7496,84.7137 58.1416,84.3217 58.6236,84.3217 C59.1066,84.3217 59.4976,84.7137 59.4976,85.1957"
            fill="#0B9CE5"
          />
          <path
            d="M51.1236,96.0238 L51.1236,97.7738"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M51.1236,101.2738 L51.1236,103.0238"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M54.6236,99.5238 L52.8736,99.5238"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M49.3736,99.5238 L47.6236,99.5238"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M88.688,87.8822 L56.569,62.3532"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.188,56.4526 L90.471,86.8786"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M97.19,53.1303 L92.874,86.2143"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.4947,52.7162 L95.0327,86.5952"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(56.000000, 25.710000)" fill="#FFFFFF">
            <path d="M61.4996,27.0043 C61.4996,27.0043 58.0996,24.6043 51.7996,25.6043 C45.4896,26.5943 41.1896,27.4243 41.1896,27.4243 C41.1896,27.4243 40.8596,27.0443 40.2296,26.5143 L41.3496,26.3943 C40.9796,9.9833 27.8196,2.3543 26.1296,1.4433 C26.1796,1.3943 26.2096,1.3643 26.2096,1.3643 C43.0396,-1.2957 58.8296,10.1843 61.4996,27.0043" />
            <path d="M41.3497,26.3939 L40.2297,26.5139 C38.6097,25.1649 34.9797,22.8539 29.7397,23.6839 C23.8397,24.6149 21.2197,28.6939 20.4497,30.1939 L19.6297,29.6739 C14.3897,13.6939 25.1097,2.4639 26.1297,1.4439 C27.8197,2.3539 40.9797,9.9839 41.3497,26.3939" />
            <path d="M26.0294,1.3939 L26.2094,1.3649 C26.2094,1.3649 26.1794,1.3939 26.1294,1.4439 C26.0894,1.4239 26.0494,1.4049 26.0294,1.3939" />
            <path d="M26.0294,1.3939 C26.0494,1.4049 26.0894,1.4239 26.1294,1.4439 C25.1094,2.4639 14.3894,13.6939 19.6294,29.6739 L20.4494,30.1939 C20.2694,30.5349 20.1894,30.7449 20.1894,30.7449 C20.1894,30.7449 16.4294,30.1839 10.7194,31.0839 C5.0094,31.9949 0.5694,36.6439 0.5694,36.6439 C-2.0806,19.8739 9.3094,4.1339 26.0294,1.3939" />
          </g>
          <path
            d="M82.2095,27.0746 C82.2095,27.0746 82.1795,27.1036 82.1295,27.1536 C81.1095,28.1746 70.3895,39.4036 75.6295,55.3846"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.9493,27.0639 C81.9493,27.0639 81.9793,27.0749 82.0293,27.1039 C82.0493,27.1149 82.0893,27.1339 82.1293,27.1539 C83.8193,28.0639 96.9793,35.6939 97.3493,52.1039"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.2095,27.0746 C99.0395,24.4146 114.8295,35.8936 117.4995,52.7146 C117.4995,52.7146 114.0995,50.3136 107.7995,51.3136 C101.4895,52.3036 97.1895,53.1346 97.1895,53.1346 C97.1895,53.1346 96.8595,52.7546 96.2295,52.2236 C94.6095,50.8746 90.9795,48.5636 85.7395,49.3936 C79.8395,50.3246 77.2195,54.4036 76.4495,55.9036 C76.2695,56.2446 76.1895,56.4546 76.1895,56.4546 C76.1895,56.4546 72.4295,55.8936 66.7195,56.7946 C61.0095,57.7046 56.5695,62.3536 56.5695,62.3536 C53.9195,45.5846 65.3095,29.8446 82.0295,27.1036 L82.2095,27.0746 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.3394,90.102 C90.8734,90.199 90.3274,90.119 89.8244,89.842 C88.8654,89.315 88.4274,88.268 88.8474,87.506 C89.2664,86.744 90.3904,86.589 91.3714,87.259"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M93.3956,89.7777 C93.7566,89.6737 94.1156,89.4627 94.4166,89.1507 C95.1776,88.3627 95.2876,87.2347 94.6626,86.6297 C94.0366,86.0237 92.9536,86.0427 92.3296,86.9427 C91.8376,87.6507 92.0366,89.1017 92.0366,89.1017"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="105.5181 105.936 84.5131 109.258 82.2901 95.204 103.2951 91.881"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="105.5181 105.936 84.5131 109.258 82.2901 95.204 103.2951 91.881"
          />
          <polygon
            fill="#FFFFFF"
            points="105.67 93.267 80.649 97.224 79.816 91.954 104.837 87.996"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="105.67 93.267 80.649 97.224 79.816 91.954 104.837 87.996"
          />
          <polygon
            fill="#ED0722"
            points="94.5411 90.1 95.2131 94.401 90.7061 95.105 90.0341 90.804"
          />
          <polygon
            fill="#ED0722"
            points="95.3736 95.4281 97.1436 106.7611 92.6366 107.4651 90.8666 96.1321"
          />
          <g transform="translate(17.000000, 0.710000)">
            <path
              d="M49.0572,11.6146 C46.6742,9.3186 43.5572,9.8326 43.5572,9.8326 C43.5572,9.8326 44.8412,4.1526 36.4082,1.5696 C27.9752,-1.0134 24.3092,4.4396 24.3092,4.4396 C19.7262,0.9956 16.2432,5.0136 14.5932,7.5966 C12.9432,10.1796 11.6602,12.7626 6.3442,13.3366 C1.0282,13.9106 0.4782,18.7896 0.4782,18.7896 L57.6872,18.7896"
              fill="#FFFFFF"
            />
            <path
              d="M49.0572,11.6146 C46.6742,9.3186 43.5572,9.8326 43.5572,9.8326 C43.5572,9.8326 44.8412,4.1526 36.4082,1.5696 C27.9752,-1.0134 24.3092,4.4396 24.3092,4.4396 C19.7262,0.9956 16.2432,5.0136 14.5932,7.5966 C12.9432,10.1796 11.6602,12.7626 6.3442,13.3366 C1.0282,13.9106 0.4782,18.7896 0.4782,18.7896 L57.6872,18.7896"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(105.000000, 34.710000)">
            <path
              d="M28.5674,6.431 C27.1774,5.091 25.3594,5.391 25.3594,5.391 C25.3594,5.391 26.1074,2.077 21.1874,0.571 C16.2674,-0.936 14.1284,2.244 14.1284,2.244 C11.4544,0.236 9.4234,2.579 8.4604,4.087 C7.4974,5.594 6.7494,7.101 3.6474,7.436 C0.5454,7.771 0.2244,10.618 0.2244,10.618 L33.6034,10.618"
              fill="#FFFFFF"
            />
            <path
              d="M28.5674,6.431 C27.1774,5.091 25.3594,5.391 25.3594,5.391 C25.3594,5.391 26.1074,2.077 21.1874,0.571 C16.2674,-0.936 14.1284,2.244 14.1284,2.244 C11.4544,0.236 9.4234,2.579 8.4604,4.087 C7.4974,5.594 6.7494,7.101 3.6474,7.436 C0.5454,7.771 0.2244,10.618 0.2244,10.618 L33.6034,10.618"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M35.6168,133.8022 C35.6168,133.8022 35.6168,126.1912 45.3018,126.2042 C45.3018,126.2042 47.3758,119.0142 55.9138,118.5952 C64.4508,118.1772 71.9358,125.8512 71.9358,125.8512 C71.9358,125.8512 80.4108,121.5262 84.9028,130.1482 C84.9028,130.1482 90.5338,128.4832 93.9728,130.5862"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.5762,133.7299 L35.6172,133.8019"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.4693,136.9848 C98.9083,134.8818 104.4383,136.9438 104.4383,136.9438 C108.0883,128.5868 116.7163,132.5778 116.7163,132.5778 C116.7163,132.5778 121.8893,124.9728 130.4263,125.3918 C138.9653,125.8108 141.0383,133.0018 141.0383,133.0018 L162.8293,133.0018"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
